/*
 * humo-product.js — Humo Commerce
 * Логика новой страницы товара (sections/humo-main-product.liquid):
 * галерея, выбор варианта, количество, вкладки, калькулятор рассрочки.
 *
 * Отдельный файл, а не правка theme.js: секция не использует data-product-form,
 * поэтому вендорный код товара её не инициализирует. Добавление в корзину
 * остаётся за ajaxCart из theme.js (кнопка .js-ajax-submit).
 *
 * Изменения варианта и количества рассылаются событиями на корне .humo-pdp:
 *   humo:variant-change (detail.variant), humo:qty-change (detail.qty)
 * — на них подписан humo-one-click.js.
 */
(function () {
  'use strict';

  var root = document.querySelector('.humo-pdp');
  if (!root) return; // не наша страница — ничего не делаем

  var product = null;
  var jsonEl = root.querySelector('.product-json');
  try {
    product = JSON.parse(jsonEl ? jsonEl.textContent : 'null');
  } catch (e) {
    console.error('[humo-product] product JSON parse failed', e);
    return;
  }
  if (!product || !product.variants) return;

  // Цена по запросу (метаполе custom.price_on_request): цены нет — не показываем ни сумму, ни скидку
  var priceOnRequest = root.hasAttribute('data-price-on-request');

  /* ---------- «Вы смотрели»: запись просмотра ---------- */
  // Вендорный theme.Product пишет cookie shopify_recently_viewed, но на этой секции не запускается
  // (нет data-section-type). Вызываем ту же запись из theme.js сами; читает cookie
  // sections/humo-recently-viewed.liquid. theme.js подключён defer ниже по документу и выполняется
  // после этого файла, но до DOMContentLoaded. readyState во время defer-скриптов уже 'interactive',
  // поэтому сразу вызываем только при 'complete' (скрипт добавлен после загрузки страницы).
  function recordRecentlyViewed() {
    var recorder = window.Shopify && window.Shopify.RecordViewedProducts;
    if (!recorder || typeof recorder.recordRecentlyViewed !== 'function') {
      console.warn('[humo-product] Shopify.RecordViewedProducts not found, product view is not recorded');
      return;
    }
    try {
      recorder.recordRecentlyViewed();
    } catch (e) {
      console.error('[humo-product] recordRecentlyViewed failed', e);
    }
  }
  if (document.readyState === 'complete') {
    recordRecentlyViewed();
  } else {
    document.addEventListener('DOMContentLoaded', recordRecentlyViewed);
  }

  var config = {};
  var configEl = document.getElementById('humo-pdp-config');
  try { config = JSON.parse(configEl ? configEl.textContent : '{}') || {}; } catch (e) { config = {}; }
  var strings = config.strings || {};

  var state = {
    variant: null,
    qty: 1
  };

  function emit(name, detail) {
    var event;
    try {
      event = new CustomEvent(name, { detail: detail });
    } catch (e) {
      // старые браузеры без конструктора CustomEvent
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(name, false, false, detail);
    }
    root.dispatchEvent(event);
  }

  function findVariantById(id) {
    id = Number(id);
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === id) return product.variants[i];
    }
    return null;
  }

  var idInput = root.querySelector('.humo-pdp__form [name="id"]');
  state.variant = findVariantById(idInput ? idInput.value : 0) || product.variants[0];

  /* ---------- Видео: модальный плеер ---------- */
  // Плеер лежит в <template> внутри галереи и попадает в DOM только по клику:
  // до этого браузер не скачивает ни байта видео. При закрытии узел удаляется —
  // загрузка и звук останавливаются.
  // Отладка: ?humo_debug=1 в адресе включает логи [FIX:video] в консоли.
  var DEBUG_VIDEO = /[?&]humo_debug=1(&|$)/.test(window.location.search);
  function logVideo() {
    if (!DEBUG_VIDEO || !window.console) return;
    console.log.apply(console, ['[FIX:video]'].concat([].slice.call(arguments)));
  }

  function initVideoModal(galleryEl) {
    var modal = galleryEl.querySelector('.js-humo-video-modal');
    if (!modal) return null;
    // В <body>: position: fixed не должен зависеть от transform/filter у предков.
    // Шрифт заголовков из настроек секции переносим вместе с модалкой.
    var headingFont = window.getComputedStyle(root).getPropertyValue('--humo-font-heading');
    if (headingFont) modal.style.setProperty('--humo-font-heading', headingFont.trim());
    document.body.appendChild(modal);

    var stage = modal.querySelector('.js-humo-video-stage');
    var dialog = modal.querySelector('.humo-video-modal__dialog');
    var closeBtn = modal.querySelector('.humo-video-modal__close');
    var opener = null;

    function setLoading(on) {
      modal.classList.toggle('humo-video-modal--loading', on);
    }

    function open(videoId, source) {
      var tpl = galleryEl.querySelector('template[data-video-id="' + videoId + '"]');
      if (!tpl || !tpl.content) {
        console.error('[FIX:video] video template not found', { videoId: videoId });
        return;
      }
      opener = source || null;
      stage.innerHTML = '';
      dialog.style.setProperty('--humo-video-ratio', tpl.getAttribute('data-aspect') || '1.7778');
      stage.appendChild(document.importNode(tpl.content, true));

      modal.hidden = false;
      document.documentElement.classList.add('humo-modal-open');
      document.addEventListener('keydown', onKeydown);
      setLoading(true);
      logVideo('open', { videoId: videoId });

      var video = stage.querySelector('video');
      var frame = stage.querySelector('iframe');
      if (video) {
        video.addEventListener('playing', function () { setLoading(false); logVideo('playing', video.currentSrc); });
        video.addEventListener('canplay', function () { setLoading(false); });
        video.addEventListener('waiting', function () { setLoading(true); });
        video.addEventListener('error', function () {
          setLoading(false);
          console.error('[FIX:video] video failed to load', { videoId: videoId, src: video.currentSrc });
        }, true);
        // Клик — жест пользователя, поэтому play() со звуком разрешён.
        // Если браузер всё же откажет — остаются стандартные контролы.
        var playing = video.play();
        if (playing && playing.catch) {
          playing.catch(function (err) {
            setLoading(false);
            logVideo('autoplay rejected', err && err.name);
          });
        }
        video.focus();
      } else if (frame) {
        frame.addEventListener('load', function () { setLoading(false); });
        closeBtn.focus();
      } else {
        setLoading(false);
        closeBtn.focus();
      }
    }

    function close() {
      if (modal.hidden) return;
      var video = stage.querySelector('video');
      if (video) video.pause();
      stage.innerHTML = '';
      setLoading(false);
      modal.hidden = true;
      document.documentElement.classList.remove('humo-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (opener) opener.focus();
      logVideo('close');
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      // Ловушка фокуса: крестик ↔ плеер
      var items = modal.querySelectorAll('button, video, iframe');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        last.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === last) {
        first.focus();
        e.preventDefault();
      }
    }

    var closers = modal.querySelectorAll('.js-humo-video-close');
    for (var i = 0; i < closers.length; i++) closers[i].addEventListener('click', close);

    return { open: open };
  }

  /* ---------- Галерея ---------- */
  var gallery = (function initGallery() {
    var el = root.querySelector('.js-humo-gallery');
    var image = el ? el.querySelector('.js-humo-gallery-image') : null;
    var thumbs = el ? el.querySelectorAll('.humo-gallery__thumb') : [];
    if (!el || !image) return { showMedia: function () {} };

    // Кнопка «Смотреть видео» на главном слайде; data-video-id — текущее видео
    var play = el.querySelector('.js-humo-gallery-play');
    var duration = el.querySelector('.js-humo-gallery-duration');
    var player = play ? initVideoModal(el) : null;
    if (play && player) {
      play.addEventListener('click', function () {
        player.open(play.getAttribute('data-video-id'), play);
      });
    }

    if (thumbs.length < 2) return { showMedia: function () {} };

    var counter = el.querySelector('.js-humo-gallery-current');
    var current = Number(el.getAttribute('data-start-index')) || 0;

    function show(index) {
      var count = thumbs.length;
      index = ((index % count) + count) % count; // по кругу в обе стороны
      var thumb = thumbs[index];

      image.setAttribute('srcset', thumb.getAttribute('data-srcset'));
      image.setAttribute('src', thumb.getAttribute('data-src'));
      image.setAttribute('alt', thumb.getAttribute('data-alt'));

      // Слайд-видео: обложка + кнопка запуска; плеер грузится только по клику
      var videoId = thumb.getAttribute('data-video-id');
      el.querySelector('.humo-gallery__main').classList.toggle('humo-gallery__main--video', !!videoId);
      if (play) {
        play.hidden = !videoId;
        if (videoId) play.setAttribute('data-video-id', videoId);
      }
      if (duration) {
        duration.textContent = thumb.getAttribute('data-duration') || '';
        duration.hidden = !duration.textContent;
      }

      thumbs[current].classList.remove('humo-gallery__thumb--active');
      thumbs[current].removeAttribute('aria-current');
      thumb.classList.add('humo-gallery__thumb--active');
      thumb.setAttribute('aria-current', 'true');

      // Прокручиваем ленту миниатюр, но не саму страницу
      var list = thumb.parentNode;
      if (list.scrollHeight > list.clientHeight) {
        list.scrollTop = thumb.offsetTop - list.offsetTop - (list.clientHeight - thumb.offsetHeight) / 2;
      }
      if (list.scrollWidth > list.clientWidth) {
        list.scrollLeft = thumb.offsetLeft - list.offsetLeft - (list.clientWidth - thumb.offsetWidth) / 2;
      }

      if (counter) counter.textContent = String(index + 1);
      current = index;
    }

    for (var i = 0; i < thumbs.length; i++) {
      thumbs[i].addEventListener('click', function () {
        show(Number(this.getAttribute('data-index')));
      });
    }

    var prev = el.querySelector('.js-humo-gallery-prev');
    var next = el.querySelector('.js-humo-gallery-next');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });

    // Стрелки клавиатуры, когда фокус внутри галереи
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(current - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { show(current + 1); e.preventDefault(); }
    });

    return {
      // Переход к фото варианта (featured_media.id)
      showMedia: function (mediaId) {
        if (!mediaId) return;
        for (var j = 0; j < thumbs.length; j++) {
          if (Number(thumbs[j].getAttribute('data-media-id')) === Number(mediaId)) {
            show(j);
            return;
          }
        }
      }
    };
  })();

  /* ---------- Деньги ---------- */
  // Порт стандартного Shopify.formatMoney: цены в JSON в минимальных единицах (тийины)
  function formatMoney(cents, format) {
    format = format || config.money_format || '{{amount}}';
    cents = Number(cents) || 0;

    function withDelimiters(number, precision, thousands, decimal) {
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;

    var value;
    switch (match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2, ',', '.');
    }
    return format.replace(match[0], value);
  }

  /* ---------- Блок покупки ---------- */
  var ui = {
    price: root.querySelector('.js-humo-price'),
    compare: root.querySelector('.js-humo-compare'),
    savings: root.querySelector('.js-humo-savings'),
    savingsValue: root.querySelector('.js-humo-savings-value'),
    discountBadge: root.querySelector('.js-humo-discount-badge'),
    skuWrap: root.querySelector('.humo-pdp__sku'),
    sku: root.querySelector('.js-humo-sku'),
    stock: root.querySelector('.js-humo-stock'),
    stockText: root.querySelector('.js-humo-stock-text'),
    atc: root.querySelector('.js-humo-atc'),
    variantSelect: root.querySelector('.js-humo-variant'),
    qty: root.querySelector('.js-humo-qty'),
    qtyMinus: root.querySelector('.js-humo-qty-minus'),
    qtyPlus: root.querySelector('.js-humo-qty-plus')
  };

  function maxQty(variant) {
    if (variant && variant.inventory_management === 'shopify' &&
        variant.inventory_policy === 'deny' && variant.inventory_quantity > 0) {
      return variant.inventory_quantity;
    }
    return 0; // 0 — без ограничения
  }

  function renderVariant(variant) {
    var onSale = !priceOnRequest && variant.compare_at_price > variant.price;

    if (ui.price) ui.price.textContent = formatMoney(variant.price);
    if (ui.compare) {
      ui.compare.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
      ui.compare.hidden = !onSale;
    }
    if (ui.savings) ui.savings.hidden = !onSale;
    if (ui.savingsValue) ui.savingsValue.textContent = onSale ? formatMoney(variant.compare_at_price - variant.price) : '';
    if (ui.discountBadge) {
      var percent = onSale ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
      ui.discountBadge.textContent = '−' + percent + '%';
      ui.discountBadge.hidden = percent <= 0;
    }

    if (ui.sku) ui.sku.textContent = variant.sku || '';
    if (ui.skuWrap) ui.skuWrap.hidden = !variant.sku;

    if (ui.stock) ui.stock.classList.toggle('humo-pdp__stock--out', !variant.available);
    if (ui.stockText) ui.stockText.textContent = variant.available ? strings.in_stock : strings.out_of_stock;

    if (ui.atc) {
      ui.atc.disabled = !variant.available;
      ui.atc.value = variant.available ? strings.add_to_cart : strings.sold_out;
    }

    var limit = maxQty(variant);
    if (ui.qty) {
      if (limit > 0) {
        ui.qty.setAttribute('max', String(limit));
      } else {
        ui.qty.removeAttribute('max');
      }
      if (limit > 0 && state.qty > limit) setQty(limit);
    }

    if (variant.featured_media && variant.featured_media.id) {
      gallery.showMedia(variant.featured_media.id);
    }

    syncOneClick(variant);
  }

  /* ---------- Синхронизация «Купить в один клик» ---------- */
  // Модалка читает цену и id из своих data-атрибутов — держим их в актуальном состоянии
  function syncOneClick(variant) {
    var modal = root.querySelector('.js-humo-one-click');
    var trigger = root.querySelector('.js-humo-one-click-open');
    var installmentTrigger = root.querySelector('.js-humo-installment-open');
    // «Узнать цену» доступна и без наличия: это вопрос менеджеру, а не заказ
    if (trigger && !trigger.hasAttribute('data-price-request')) trigger.disabled = !variant.available;
    if (installmentTrigger) installmentTrigger.disabled = !variant.available;
    if (!modal) return;

    var title = product.title;
    if (product.variants.length > 1 && variant.title) title += ' — ' + variant.title;

    modal.setAttribute('data-variant-id', String(variant.id));
    modal.setAttribute('data-product-price', String(variant.price));
    modal.setAttribute('data-product-title', title);

    var titleEl = modal.querySelector('.js-humo-one-click-title');
    var priceEl = modal.querySelector('.js-humo-one-click-price');
    var skuEl = modal.querySelector('.js-humo-one-click-sku');
    var skuWrap = modal.querySelector('.js-humo-one-click-sku-wrap');
    if (titleEl) titleEl.textContent = title;
    if (priceEl && !priceOnRequest) priceEl.textContent = formatMoney(variant.price);
    if (skuEl) skuEl.textContent = variant.sku || '';
    if (skuWrap) skuWrap.hidden = !variant.sku;

    // Картинку варианта берём у миниатюры галереи с тем же media id
    var image = modal.querySelector('.js-humo-one-click-image');
    var mediaId = variant.featured_media && variant.featured_media.id;
    var thumbImg = mediaId ? root.querySelector('.humo-gallery__thumb[data-media-id="' + mediaId + '"] img') : null;
    if (image && thumbImg) {
      image.removeAttribute('srcset');
      image.setAttribute('src', thumbImg.getAttribute('src'));
    }
  }

  function setVariant(variant) {
    state.variant = variant;
    renderVariant(variant);

    // ?variant= в адресе — чтобы ссылкой можно было поделиться
    if (window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* старый браузер без URL — адрес просто не меняем */ }
    }

    emit('humo:variant-change', { variant: variant });
  }

  if (ui.variantSelect) {
    ui.variantSelect.addEventListener('change', function () {
      var variant = findVariantById(this.value);
      if (!variant) {
        console.error('[humo-product] variant not found', this.value);
        return;
      }
      setVariant(variant);
    });
  }

  /* ---------- Количество ---------- */
  function setQty(value) {
    var limit = maxQty(state.variant);
    value = parseInt(value, 10);
    if (!value || value < 1) value = 1;
    if (limit > 0 && value > limit) value = limit;

    if (ui.qty) ui.qty.value = String(value);
    if (ui.qtyMinus) ui.qtyMinus.disabled = value <= 1;
    if (ui.qtyPlus) ui.qtyPlus.disabled = limit > 0 && value >= limit;

    if (value !== state.qty) {
      state.qty = value;
      emit('humo:qty-change', { qty: value });
    }
  }

  if (ui.qty) {
    if (ui.qtyMinus) ui.qtyMinus.addEventListener('click', function () { setQty(state.qty - 1); });
    if (ui.qtyPlus) ui.qtyPlus.addEventListener('click', function () { setQty(state.qty + 1); });
    ui.qty.addEventListener('change', function () { setQty(this.value); });
    setQty(ui.qty.value);
  }

  /* ---------- Подпись кнопки «В корзину» ---------- */
  // ajaxCart из theme.js через 3 с после добавления пишет в кнопку свой текст
  // (products.product.add_to_cart, заглавными). Возвращаем подпись из дизайна.
  var LABEL_CHECK_EVERY = 250;   // мс
  var LABEL_CHECK_LIMIT = 12000; // мс — дольше ajaxCart текст не держит
  var labelTimer = null;

  if (ui.atc && strings.add_to_cart && strings.vendor_add_to_cart !== strings.add_to_cart) {
    ui.atc.addEventListener('click', function () {
      var started = Date.now();
      clearInterval(labelTimer);
      labelTimer = setInterval(function () {
        if (ui.atc.value === strings.vendor_add_to_cart) {
          ui.atc.value = state.variant.available ? strings.add_to_cart : strings.sold_out;
          clearInterval(labelTimer);
        } else if (Date.now() - started > LABEL_CHECK_LIMIT) {
          clearInterval(labelTimer);
        }
      }, LABEL_CHECK_EVERY);
    });
  }

  /* ---------- Вкладки ---------- */
  (function initTabs() {
    var el = root.querySelector('.js-humo-tabs');
    if (!el) return;
    var tabs = el.querySelectorAll('[role="tab"]');
    if (tabs.length < 2) return; // одна вкладка — переключать нечего

    function select(index, focus) {
      for (var i = 0; i < tabs.length; i++) {
        var active = i === index;
        var panel = document.getElementById(tabs[i].getAttribute('aria-controls'));
        tabs[i].setAttribute('aria-selected', active ? 'true' : 'false');
        tabs[i].setAttribute('tabindex', active ? '0' : '-1');
        tabs[i].classList.toggle('humo-tabs__tab--active', active);
        if (panel) panel.hidden = !active;
      }
      if (focus) tabs[index].focus();
    }

    for (var i = 0; i < tabs.length; i++) {
      (function (index) {
        tabs[index].addEventListener('click', function () { select(index, false); });
        tabs[index].addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (e.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (next !== null) {
            e.preventDefault();
            select(next, true);
          }
        });
      })(i);
    }

    // Без JS видны все панели; с JS — только первая
    select(0, false);
  })();

  /* ---------- Калькулятор рассрочки ---------- */
  var installment = (function initInstallment() {
    var el = root.querySelector('.js-humo-installment');
    if (!el) return { update: function () {} };

    var providers = el.querySelectorAll('.js-humo-installment-provider');
    var termGroups = el.querySelectorAll('.js-humo-installment-terms');
    var out = {
      monthly: el.querySelector('.js-humo-installment-monthly'),
      markup: el.querySelector('.js-humo-installment-markup'),
      markupLabel: el.querySelector('.js-humo-installment-markup-label'),
      total: el.querySelector('.js-humo-installment-total')
    };
    var NBSP = '\u00a0';

    // Как humo-format-sum.liquid: целое число, разряды через неразрывный пробел
    function formatSum(value) {
      return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
    }

    function activeGroup() {
      for (var i = 0; i < termGroups.length; i++) {
        if (!termGroups[i].hidden) return termGroups[i];
      }
      return null;
    }

    function update() {
      var group = activeGroup();
      var term = group ? group.querySelector('.humo-installment__term--active') : null;
      if (!term) return;

      var months = Number(term.getAttribute('data-months')) || 1;
      var rate = Number(term.getAttribute('data-rate')) || 0;
      var base = state.variant.price / 100 * state.qty; // цены в JSON — в тийинах
      var total = base * (1 + rate / 100);

      if (out.monthly) out.monthly.textContent = formatSum(total / months);
      if (out.markup) out.markup.textContent = formatSum(total - base);
      if (out.total) out.total.textContent = formatSum(total);
      if (out.markupLabel && strings.markup) out.markupLabel.textContent = strings.markup.replace('__RATE__', rate);
    }

    function selectTerm(button) {
      var terms = button.parentNode.querySelectorAll('.js-humo-installment-term');
      for (var i = 0; i < terms.length; i++) {
        var active = terms[i] === button;
        terms[i].classList.toggle('humo-installment__term--active', active);
        terms[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
      update();
    }

    function selectProvider(index) {
      for (var i = 0; i < providers.length; i++) {
        var active = Number(providers[i].getAttribute('data-provider')) === index;
        providers[i].classList.toggle('humo-installment__provider--active', active);
        providers[i].setAttribute('aria-pressed', active ? 'true' : 'false');
      }
      for (var j = 0; j < termGroups.length; j++) {
        var group = termGroups[j];
        var shown = Number(group.getAttribute('data-provider')) === index;
        group.hidden = !shown;
        if (shown) {
          // Смена провайдера — снова самый длинный срок (как в дизайне)
          var terms = group.querySelectorAll('.js-humo-installment-term');
          if (terms.length) selectTerm(terms[terms.length - 1]);
        }
      }
    }

    el.addEventListener('click', function (e) {
      var target = e.target.closest ? e.target : null;
      if (!target) return;
      var provider = target.closest('.js-humo-installment-provider');
      var term = target.closest('.js-humo-installment-term');
      if (provider) selectProvider(Number(provider.getAttribute('data-provider')));
      if (term) selectTerm(term);
    });

    return { update: update };
  })();

  root.addEventListener('humo:variant-change', installment.update);
  root.addEventListener('humo:qty-change', installment.update);

  /* ---------- Доставка ---------- */
  // Как в тарифах Shopify: сумма (цена × количество) от порога — бесплатно, ниже — цена из data-cost.
  // Корзину не учитываем: считаем только этот товар, как его и видит покупатель на карточке.
  var delivery = (function initDelivery() {
    var el = root.querySelector('.js-humo-delivery');
    var threshold = el ? Number(el.getAttribute('data-free-threshold')) : 0;
    if (!el || !threshold) return { update: function () {} };

    var freeText = el.getAttribute('data-free-text') || '';
    var costs = el.querySelectorAll('.js-humo-delivery-cost');
    var thresholdNote = el.querySelector('.js-humo-delivery-threshold');
    var freeNote = root.querySelector('.js-humo-free-note');

    function update() {
      var free = state.variant.price * state.qty >= threshold; // оба значения в тийинах

      for (var i = 0; i < costs.length; i++) {
        var cost = Number(costs[i].getAttribute('data-cost'));
        costs[i].textContent = free || !cost ? freeText : formatMoney(cost);
      }
      if (thresholdNote) thresholdNote.hidden = free;
      if (freeNote) freeNote.hidden = !free;
    }

    return { update: update };
  })();

  root.addEventListener('humo:variant-change', delivery.update);
  root.addEventListener('humo:qty-change', delivery.update);
  delivery.update();
})();
